import { Grid, Box, Container, Stack, Typography } from "@mui/material";
import KpiCard from "../../components/ui/kpiCard";
import Page from "../../components/Page";
import { RetentionKpis } from "./ui/fidelite/RetentionKpis";
import { RetentionRateChart } from "./ui/fidelite/RetentionRateChart";
import { RetentionCohortChart } from "./ui/fidelite/RetentionCohortChat";
import { VipCustomersTable } from "./ui/fidelite/VipCustomersTables";
import { RetentionActions } from "./ui/fidelite/RetentionActions";



export default function Fidelite() {
    return (
        <Page title="Analyse">
            <Container sx={{ marginTop: { xs: 3, sm: 0 } }}>
                <Stack spacing={5}>
                    <Box>
                        <Typography variant="h4">Fidélité</Typography>
                        <Typography color={'text.secondary'} fontSize={16}>Rétention et fidélité clients : taux de retour, LTV et engagement.</Typography>
                    </Box>
                    <Box>
                        <RetentionKpis />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <RetentionRateChart
                                    data={[
                                        { month: 'Jan', rate: 35 },
                                        { month: 'Fév', rate: 38 },
                                        { month: 'Mar', rate: 42 },
                                        { month: 'Avr', rate: 45 },
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <RetentionCohortChart
                                    data={[
                                        { cohort: 'Jan', returning: 120 },
                                        { cohort: 'Fév', returning: 95 },
                                        { cohort: 'Mar', returning: 80 },
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12} md={8}>
                                <VipCustomersTable
                                    customers={[
                                        {
                                            id: 1,
                                            name: 'Jean K.',
                                            events: 6,
                                            amount: '120 000',
                                        },
                                        {
                                            id: 2,
                                            name: 'Aïcha B.',
                                            events: 5,
                                            amount: '98 000',
                                        },
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <RetentionActions />
                            </Grid>
                        </Grid>
                    </Box>
                </Stack>

            </Container>

        </Page>

    );
}
